var map = {
	"./logo-light-1.png": 94,
	"./logo-light-2.png": 95,
	"./logo-light-3.png": 96,
	"./logo-light-4.png": 97,
	"./logo-light-5.png": 98,
	"./logo-light-6.png": 99,
	"./logo-light-7.png": 100,
	"./logo-light-8.png": 101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93;